export const shoppingCarts = (state) => state.offers.shoppingCarts || [];
